/**
 * @module cercaliagl/layer/ActiveFires
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Base from './Base';
/**
 * @const
 * @type {string}
 */
var ID = 'active-fires-layer';
/**
 * @const
 * @type {string}
 */
var LAYER_URL = 'https://maps.effis.emergency.copernicus.eu/gwis';
/**
 * @type {import("./WMS").WMSParameters}
 */
var ActiveFiresParams = {
    service: 'WMS',
    version: '1.1.1',
    request: 'GetMap',
    format: 'image/png',
    projection: 'EPSG:3857',
    srs: 'EPSG:3857',
    transparent: true,
    layers: 'viirs.hs',
    width: 1024,
    height: 1024,
    styles: '',
};
/**
 * @classdesc
 * @extends {Base}
 */
var ActiveFires = /** @class */ (function (_super) {
    __extends(ActiveFires, _super);
    /**
     * @constructor
     */
    function ActiveFires() {
        var _this = _super.call(this, {
            id: ID,
            type: 'raster',
            map: null,
        }) || this;
        /**
         * @private
         * @type {import("../Map").default}
         */
        _this.cercaliaMap_ = null;
        /**
         * @private
         * @type {import("maplibre-gl").Map}
         */
        _this.map_ = null;
        /**
         * @private
         * @type {import("./WMS").WMSParameters}
         */
        _this.params_ = ActiveFiresParams;
        /**
         * @private
         * @type {string}
         */
        _this.layerUrl_ = _this.formatUrl_(LAYER_URL);
        return _this;
    }
    /**
     * Initialize the active fires layer.
     */
    ActiveFires.prototype.initialize = function () {
        if (this.map_) {
            this.addToMap_();
        }
    };
    ActiveFires.prototype.clear = function () {
        // TODO: eliminar de la branca roadmap-2025, allà ja té el mètode la classe Base
        this.setMap(null);
    };
    /**
     * @param {import("../Map").default|null} map Map or null
     */
    ActiveFires.prototype.setMap = function (map) {
        if (map) {
            this.cercaliaMap_ = map;
            this.map_ = map.getMapboxglMap();
            this.addToMap_();
        }
        else {
            this.removeFromMap_();
        }
    };
    /**
     * @private
     * Add layer to map
     */
    ActiveFires.prototype.addToMap_ = function () {
        if (!this.map_)
            return;
        if (!this.map_.getSource(this.id_)) {
            this.map_.addSource(this.id_, {
                type: 'raster',
                tiles: [this.layerUrl_],
                tileSize: ActiveFiresParams.width,
            });
        }
        if (!this.map_.getLayer(this.id_)) {
            this.map_.addLayer({
                id: this.id_,
                type: 'raster',
                source: this.id_,
                paint: {},
            });
        }
    };
    /**
     * @private
     * Remove layer from map
     */
    ActiveFires.prototype.removeFromMap_ = function () {
        if (!this.map_)
            return;
        if (this.map_.getLayer(this.id_)) {
            this.map_.removeLayer(this.id_);
        }
        if (this.map_.getSource(this.id_)) {
            this.map_.removeSource(this.id_);
        }
    };
    /**
     * @private
     * @param {string} baseUrl
     * @return {string}
     */
    ActiveFires.prototype.formatUrl_ = function (baseUrl) {
        var params = [];
        Object.entries(this.params_).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var keylc = key.toLocaleLowerCase();
            params.push("".concat(keylc, "=").concat(value));
        });
        var today = new Date().toISOString().split('T')[0];
        var yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().split('T')[0];
        var bboxEpsg = 'bbox-epsg-3857';
        return "".concat(baseUrl, "?").concat(params.join('&'), "&bbox={").concat(bboxEpsg, "}&time=").concat(yesterday, "/").concat(today);
    };
    return ActiveFires;
}(Base));
export default ActiveFires;
//# sourceMappingURL=ActiveFires.js.map